export const FETCH_OPERATORS_FAILED_MESSAGE = "error:operators.fetch-operators-failed"
export const DELETE_FROM_QUEUE_FAILED_MESSAGE = "error:operators.delete-from-queue-failed"
export const UPDATE_OPERATOR_QUEUES_FAILED_MESSAGE = "error:operators.update-operator-queues-failed"
export const MAKE_OFFLINE_FAILED_MESSAGE = "error:operators.make-offline-failed"
